import { snakeCase } from 'lodash-es';
import { analytics } from '../segment';

type ButtonClickedParams = {
  button_name:
    | 'edit_order'
    | 'save_order'
    | 'cart_tooltip_close'
    | 'cart_tooltip_next';
  order_id: number;
};

export function onboardingButtonClicked(params: ButtonClickedParams) {
  analytics.track('Onboarding Button Clicked', {
    ...params,
    button_name: snakeCase(params.button_name),
  });
}
